import { CerFormAdapter } from '@form/cer-form-adapter';

import { CerFormViewSet } from '@form/cer-form-view-set';
import { CerFormView } from '@form/cer-form-view';

export class VendorGroupForm extends CerFormAdapter {

  public override viewSetInit(viewSet: CerFormViewSet) {
    viewSet.viewAdd(this.viewGet());
  }

  private viewGet(): CerFormView {

    const view = new CerFormView();
    view.viewMetadata = {
      name: 'kreditor-grupper', dataApiName: 'VendorGroup', text: 'Kreditorgrupper', textSingular: 'Kreditorgruppe',
      primaryKey: 'num', titleFields: ['num', 'name'], baseFields: ['id', 'num', 'name', 'history']
    };
    view.fieldMetadata =
      [
        { name: 'legacyId', text: 'Ekstern id' },
      ];
    return view;
  }
}
